export default {
  SET_SUPPORTED_LANGUAGES: "SET_SUPPORTED_LANGUAGES",
  SET_APP_CONFIGS: "SET_APP_CONFIGS",
};
